import { CommonModule } from '@angular/common';
import { Component, Inject, NgModule, OnInit, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { WINDOW } from '@app/common/app-tokens';
import { LinkModule } from '@app/directives/link.directive';
import { FirstDayHeroModule } from '@app/views/first-day-wizard/first-day-hero/first-day-hero.component';

@Component({
  selector: 'app-first-day-dialog',
  templateUrl: './first-day-dialog.component.html',
  styleUrls: ['./first-day-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FirstDayDialogComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<FirstDayDialogComponent>, private router: Router, @Inject(WINDOW) private window: Window) {
  }

  onBtnClick() {
    this.router.navigate(['/first-day'])
      .then(() => {
        this.dialogRef.close();
      });
  }

  ngOnInit() {
    if (this.router.url.indexOf('first-day') >= 0) {
      this.window.setTimeout(() => {
        this.dialogRef.close();
      }, 0);
    }
  }

}
@NgModule({
  declarations: [FirstDayDialogComponent],
  entryComponents: [FirstDayDialogComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    FirstDayHeroModule,
    LinkModule,
  ]
})
export class FirstDayDialogModule { }
